import { EVENT_TYPE } from '@/common/resources/const'

export const eventMapper = {
  onClick: EVENT_TYPE.ON_CLICK,
  onNavigation: EVENT_TYPE.ON_NAVIGATION,
  onDisplay: EVENT_TYPE.ON_DISPLAY,
  onViewMore: EVENT_TYPE.ON_VIEW_MORE,
  onDetail: EVENT_TYPE.ON_DETAIL,
  onZzim: EVENT_TYPE.ON_ZZIM,
  offZzim: EVENT_TYPE.OFF_ZZIM,
  onInstantPlay: EVENT_TYPE.ON_INSTANT_PLAY,
}

/**
 * eventList 에서 event 에 해당하는 이벤트를 찾아 반환
 * @param eventList
 * @param event // string
 * @returns {*}
 */
export const getEventFromEventList = (eventList = [], event = '') => {
  return eventList.find((evt) => evt?.type === eventMapper[event])
}

/**
 * eventList 에서 events [] 에 해당하는 이벤트들을 찾아 반환
 * @param eventList
 * @param events // []
 * @returns {*}
 */
export const getEventsFromEventList = (eventList = [], events = []) => {
  return events.reduce((acc, currentEvent) => {
    return {
      ...acc,
      [currentEvent]: getEventFromEventList(eventList, currentEvent),
    }
  }, {})
}
